import { Navigate, Route, Routes } from "react-router";

import AuthorizedRoute from "../components/Routes/AuthorizedRoutes";

import SvarUtBrevHistorikk from "../components/Common/Detalj/SvarUtBrevhistorikk";
import ImageEditorPageContainer from "../components/Common/Miljogebyr/Detalj/ImageEditorPageContainer";
import MiljogebyrOrginalbilde from "../components/Common/Miljogebyr/Detalj/MiljogebyrOrginalbilde";
import TidskontrollOrginalbilde from "../components/Common/Miljogebyr/Detalj/TidskontrollOrginalbilde";
import MiljogebyrDetaljPage from "../components/Miljogebyr/Detalj/MiljogebyrDetaljPage";
import MiljogebyrerPage from "../components/Miljogebyr/MiljogebyrerPage";
import MiljokontrollDetaljPage from "../components/Miljogebyr/Miljokontroll/Detalj/MiljokontrollDetaljPage";
import OversiktUtskriftContainer from "../components/Miljogebyr/Oversikt/UtskriftContainer";
import TilBehandlingUtskriftContainer from "../components/Miljogebyr/TilBehandling/UtskriftContainer";

import { bypatruljen, juridisk } from "../constants/roles";
import sitePath from "../constants/sitePaths";

// Role groups
const ALL = [...Object.values(bypatruljen), ...Object.values(juridisk)];
const MK_EDIT = [
  bypatruljen.saksbehandleradmin,
  bypatruljen.saksbehandler,
  bypatruljen.driftleder,
  juridisk.saksbehandler,
];
const SVAT = [
  bypatruljen.saksbehandler,
  bypatruljen.saksbehandleradmin,
  juridisk.ledelse,
  juridisk.saksbehandler,
];
const SVAT_ETT = [bypatruljen.saksbehandler, bypatruljen.saksbehandleradmin];
const EDIT = [
  bypatruljen.saksbehandleradmin,
  bypatruljen.saksbehandler,
  juridisk.saksbehandler,
];

const Miljogebyrer = () => (
  <Routes>
    {/* oversikt — detalj routes take priority over the catch-all above */}
    <Route path="oversikt">
      <Route
        index
        element={
          <AuthorizedRoute roles={ALL}>
            <MiljogebyrerPage />
          </AuthorizedRoute>
        }
      />
      <Route
        path="utskrift"
        element={
          <AuthorizedRoute roles={ALL}>
            <OversiktUtskriftContainer />
          </AuthorizedRoute>
        }
      />
      <Route
        path=":id"
        element={
          <AuthorizedRoute roles={ALL}>
            <MiljogebyrDetaljPage />
          </AuthorizedRoute>
        }
      />
      <Route
        path=":id/svar-ut/:svarUtId/historikk"
        element={
          <AuthorizedRoute roles={SVAT}>
            <SvarUtBrevHistorikk />
          </AuthorizedRoute>
        }
      />
      <Route
        path=":id/bilder/:bildeId"
        element={
          <AuthorizedRoute roles={ALL}>
            <MiljogebyrOrginalbilde />
          </AuthorizedRoute>
        }
      />
      <Route
        path=":id/bilder/:bildeId/rediger"
        element={
          <AuthorizedRoute roles={EDIT}>
            <ImageEditorPageContainer />
          </AuthorizedRoute>
        }
      />
      <Route
        path=":miljogebyrId/tidskontroller/:id"
        element={
          <AuthorizedRoute roles={MK_EDIT}>
            <MiljokontrollDetaljPage />
          </AuthorizedRoute>
        }
      />
      <Route
        path=":id/tidskontroller/:miljokontrollId/observasjoner/:observasjonId/bilder/:bildeId"
        element={
          <AuthorizedRoute roles={ALL}>
            <TidskontrollOrginalbilde />
          </AuthorizedRoute>
        }
      />
      <Route
        path=":id/tidskontroller/:miljokontrollId/observasjoner/:observasjonId/bilder/:bildeId/rediger"
        element={
          <AuthorizedRoute roles={EDIT}>
            <ImageEditorPageContainer />
          </AuthorizedRoute>
        }
      />
    </Route>

    {/* til-behandling */}
    <Route path="til-behandling">
      <Route
        index
        element={
          <AuthorizedRoute roles={ALL}>
            <MiljogebyrerPage />
          </AuthorizedRoute>
        }
      />
      <Route
        path="utskrift"
        element={
          <AuthorizedRoute roles={ALL}>
            <TilBehandlingUtskriftContainer />
          </AuthorizedRoute>
        }
      />
      <Route
        path=":id"
        element={
          <AuthorizedRoute roles={ALL}>
            <MiljogebyrDetaljPage />
          </AuthorizedRoute>
        }
      />
      <Route
        path=":id/svar-ut/:svarUtId/historikk"
        element={
          <AuthorizedRoute roles={SVAT_ETT}>
            <SvarUtBrevHistorikk />
          </AuthorizedRoute>
        }
      />
      <Route
        path=":id/bilder/:bildeId"
        element={
          <AuthorizedRoute roles={ALL}>
            <MiljogebyrOrginalbilde />
          </AuthorizedRoute>
        }
      />
      <Route
        path=":id/bilder/:bildeId/rediger"
        element={
          <AuthorizedRoute roles={EDIT}>
            <ImageEditorPageContainer />
          </AuthorizedRoute>
        }
      />
      <Route
        path=":miljogebyrId/tidskontroller/:id"
        element={
          <AuthorizedRoute roles={MK_EDIT}>
            <MiljokontrollDetaljPage />
          </AuthorizedRoute>
        }
      />
      <Route
        path=":id/tidskontroller/:miljokontrollId/observasjoner/:observasjonId/bilder/:bildeId"
        element={
          <AuthorizedRoute roles={ALL}>
            <TidskontrollOrginalbilde />
          </AuthorizedRoute>
        }
      />
      <Route
        path=":id/tidskontroller/:miljokontrollId/observasjoner/:observasjonId/bilder/:bildeId/rediger"
        element={
          <AuthorizedRoute roles={EDIT}>
            <ImageEditorPageContainer />
          </AuthorizedRoute>
        }
      />
    </Route>

    {/* tidskontrolloversikt — miljokontroll list + miljogebyr detalj accessed from here */}
    <Route path="tidskontrolloversikt">
      <Route
        index
        element={
          <AuthorizedRoute roles={ALL}>
            <MiljogebyrerPage />
          </AuthorizedRoute>
        }
      />
      <Route
        path=":id"
        element={
          <AuthorizedRoute roles={MK_EDIT}>
            <MiljokontrollDetaljPage />
          </AuthorizedRoute>
        }
      />
      <Route
        path=":miljokontrollId/observasjoner/:observasjonId/bilder/:bildeId"
        element={
          <AuthorizedRoute roles={ALL}>
            <TidskontrollOrginalbilde />
          </AuthorizedRoute>
        }
      />
      <Route
        path=":miljokontrollId/miljogebyrer/:id/tidskontroller/:miljokontrollId/observasjoner/:observasjonId/bilder/:bildeId/rediger"
        element={
          <AuthorizedRoute roles={EDIT}>
            <ImageEditorPageContainer />
          </AuthorizedRoute>
        }
      />

      {/* miljogebyr detalj reached from tidskontrolloversikt/:id/miljogebyrer */}
      <Route
        path=":miljokontrollId/miljogebyrer/:id"
        element={
          <AuthorizedRoute roles={MK_EDIT}>
            <MiljogebyrDetaljPage />
          </AuthorizedRoute>
        }
      />
      <Route
        path=":miljokontrollId/miljogebyrer/:id/svar-ut/:svarUtId/historikk"
        element={
          <AuthorizedRoute roles={SVAT_ETT}>
            <SvarUtBrevHistorikk />
          </AuthorizedRoute>
        }
      />
      <Route
        path=":miljokontrollId/miljogebyrer/:id/bilder/:bildeId"
        element={
          <AuthorizedRoute roles={ALL}>
            <MiljogebyrOrginalbilde />
          </AuthorizedRoute>
        }
      />
      <Route
        path=":miljokontrollId/miljogebyrer/:id/tidskontroller/:miljokontrollId/observasjoner/:observasjonId/bilder/:bildeId"
        element={
          <AuthorizedRoute roles={ALL}>
            <TidskontrollOrginalbilde />
          </AuthorizedRoute>
        }
      />
      <Route
        path=":miljokontrollId/miljogebyrer/:id/bilder/:bildeId/rediger"
        element={
          <AuthorizedRoute roles={EDIT}>
            <ImageEditorPageContainer />
          </AuthorizedRoute>
        }
      />

      {/* miljogebyr detalj reached from tidskontrolloversikt/miljogebyrer (flat) */}
      <Route
        path="miljogebyrer/:id"
        element={
          <AuthorizedRoute roles={MK_EDIT}>
            <MiljogebyrDetaljPage />
          </AuthorizedRoute>
        }
      />
      <Route
        path="miljogebyrer/:id/svar-ut/:svarUtId/historikk"
        element={
          <AuthorizedRoute roles={SVAT_ETT}>
            <SvarUtBrevHistorikk />
          </AuthorizedRoute>
        }
      />
      <Route
        path="miljogebyrer/:id/bilder/:bildeId"
        element={
          <AuthorizedRoute roles={ALL}>
            <MiljogebyrOrginalbilde />
          </AuthorizedRoute>
        }
      />
      <Route
        path="miljogebyrer/:id/bilder/:bildeId/rediger"
        element={
          <AuthorizedRoute roles={EDIT}>
            <ImageEditorPageContainer />
          </AuthorizedRoute>
        }
      />
      <Route
        path="miljogebyrer/:miljogebyrId/tidskontroller/:id"
        element={
          <AuthorizedRoute roles={MK_EDIT}>
            <MiljokontrollDetaljPage />
          </AuthorizedRoute>
        }
      />
      <Route
        path="miljogebyrer/:id/tidskontroller/:miljokontrollId/observasjoner/:observasjonId/bilder/:bildeId"
        element={
          <AuthorizedRoute roles={ALL}>
            <TidskontrollOrginalbilde />
          </AuthorizedRoute>
        }
      />
      <Route
        path="miljogebyrer/:id/tidskontroller/:miljokontrollId/observasjoner/:observasjonId/bilder/:bildeId/rediger"
        element={
          <AuthorizedRoute roles={EDIT}>
            <ImageEditorPageContainer />
          </AuthorizedRoute>
        }
      />
    </Route>

    <Route
      index
      element={
        <Navigate to={sitePath.miljogebyrer.oversikt.shortUrl} replace />
      }
    />
  </Routes>
);

export default Miljogebyrer;
